import { User } from "./user";
import { Offer } from "./offer";
export class Team {
  descr:string;
  id:number;
  name:string;
  code:string;
  members:User[];
  offers:Offer[];
  colour:string;
  tags:string[];
}

export class TeamMenuEvent{
  type?:string;
  team?:Team;
}

export const TeamMenuEventType = {
  EDIT_TEAM: 'EDIT_TEAM',
  ADD_TEAM: 'ADD_TEAM',
  DELETE_TEAM:'DELETE_TEAM',
  // NOTIFY_TEAMS:'NOTIFY_TEAMS',
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/team.ts